import { Component, OnDestroy, OnInit } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { map, startWith, takeWhile, tap } from 'rxjs/operators';
import * as fromDataServices from '../../data-services';
import { BurdenModel } from '../../data-services/burden';
import * as fromShared from '../../shared';
import {
    flatDeep,
    getDynamicColumns,
    IColumn,
    SelectItem,
    uniqBy
} from '../../shared';
import { LoggingService } from '../../shared/services/logging';
@Component({
    selector: 'ef-burden-container',
    templateUrl: './burden-container.component.html',
    styleUrls: ['./burden-container.component.scss'],
    standalone: false
})
export class BurdenContainerComponent implements OnInit, OnDestroy {
    BurdenModelDS: EntityCollectionService<fromDataServices.Burden.BurdenModel>;
    contractDS: EntityCollectionService<fromDataServices.Contract.Contract>;

    burdens$: Observable<fromDataServices.Burden.BurdenModel[]>;
    // filteredBurdens$: Observable<fromDataServices.Burden.BurdenModel[]>;
    contracts$: Observable<SelectItem[]>;
    allcontracts$: Observable<SelectItem[]>;
    chargeNumbers$: Observable<SelectItem[]>;
    contractTypes$: Observable<SelectItem[]>;
    colGroups: IColumn[] = [];
    cols: IColumn[] = [];
    private active = true;
    process$: Observable<fromShared.Process>;
    SelectContractsSubject = new ReplaySubject<string[]>(1);
    ToggleDetailsSubject = new ReplaySubject<boolean>(1);

    LoadCloneSubject = new ReplaySubject<boolean>(1);

    constructor(
        private log: LoggingService,
        public entityServices: EntityServices,
        private store: Store
    ) {
        this.log.verbose({ type: 'BurdenContainerComponent::' });
        this.BurdenModelDS =
            entityServices.getEntityCollectionService<fromDataServices.Burden.BurdenModel>(
                fromDataServices.Burden.entityName
            );
        this.contractDS =
            entityServices.getEntityCollectionService<fromDataServices.Contract.Contract>(
                fromDataServices.Contract.entityName
            );
    }
    ngOnInit(): void {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.BurdenModelDS.clearCache();
        this.contractDS.getAll();
        this.SelectContractsSubject.pipe(
            // startWith(null as string[]),
            takeWhile(() => this.active),
            tap(contracts =>
                this.log.verbose({
                    type: 'BurdenContainerComponent:SelectContractsSubject',
                    contracts
                })
            )
            // filter(contracts => !!contracts && contracts.length > 0)
        ).subscribe(contracts => {
            this.BurdenModelDS.clearCache();
            if (contracts && contracts.length > 0) {
                this.BurdenModelDS.getWithQuery(
                    JSON.stringify({
                        // ContractList: contracts
                        ContractList: contracts.map(x => ({
                            ContractListID: x,
                            ContractDesc: ''
                        }))
                    })
                );
            }
        });

        this.LoadCloneSubject.pipe(takeWhile(() => this.active)).subscribe(
            value => {
                //this.loadClone = value;
            }
        );

        this.burdens$ = combineLatest([
            this.BurdenModelDS.entities$,
            this.SelectContractsSubject
        ]).pipe(
            // filter(([items]) => items && items.length > 0),
            map(([items, contracts]) => {
                if (contracts && contracts.length > 0) {
                    if (items && items.length > 0) {
                        this.mapColumns(items[0], true);
                    }
                    return [...clone(items)];
                }
                return [];
            })
        );
        this.contracts$ = this.BurdenModelDS.entities$.pipe(
            // first call is all contracts, don't need to filter after that
            map(items => uniqBy(items, x => x.ContractListID)),
            map(items =>
                items.map(item => ({
                    label: item.ContractDesc,
                    value: item.ContractListID
                }))
            )
        );
        this.allcontracts$ = this.contractDS.entities$.pipe(
            map(contracts => contracts.filter(c => c.IsActive && c.ContractType != "FFP")),
            map(x => clone(x)),
            map(x =>
                x.sort((a, b) => a.ContractDesc.localeCompare(b.ContractDesc))
            ),
            map(items =>
                items.map(item => ({
                    label: item.ContractDesc,
                    value: item.ContractListID
                }))
            )
        );
        this.chargeNumbers$ = this.burdens$.pipe(
            map(items => uniqBy(items, x => x.ChargeNumber)),
            map(items =>
                items.map(item => ({
                    label: item.ChargeNumber,
                    value: item.ChargeNumber
                }))
            )
        );
        this.contractTypes$ = this.burdens$.pipe(
            map(items => uniqBy(items, x => x.ContractType)),
            map(items =>
                items.map(item => ({
                    label: item.ContractType,
                    value: item.ContractType
                }))
            )
        );

        // this.filteredBurdens$ = combineLatest([
        //     this.SelectContractsSubject.pipe(startWith(null as string[])),
        //     this.burdens$
        // ]).pipe(
        //     tap(([contracts, burdens]) =>
        //         this.log.verbose({
        //             type: 'BurdenContainerComponent:unfiltered',
        //             burdens,
        //             contracts
        //         })
        //     ),
        //     map(([contracts, burdens]) =>
        //         // burdens.filter(i => contracts.includes(i.ContractListID))
        //         contracts && contracts.length > 0
        //             ? burdens.filter(i => contracts.includes(i.ContractListID))
        //             : []
        //     ),
        //     tap(burdens =>
        //         this.log.verbose({
        //             type: 'BurdenContainerComponent:filtered',
        //             burdens
        //         })
        //     )
        // );
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    getColSpan(item, column) {
        // let keys = Object.keys(item[column]);
        const cols = Object.keys(item[column]);
        this.log.verbose({
            type: 'BurdenContainerComponent:getColSpan',
            cols,
            column,
            item
        });
        return cols.length;
    }

    mapColumns(item: BurdenModel, showDetails: boolean) {
        // getBudgetDynamicColumns returns the dynamic column groups, i.e 01January or Week Ending XXX
        // each of these groups has data nested under it, i.e. hours, amounts, variance, etc
        const filterItems = ['Status', 'Row_Version', 'updates'];

        const dynCols = getDynamicColumns(item, filterItems);

        this.colGroups = dynCols.map(x => ({
            field: x,
            header: x,
            colspan: this.getColSpan(item, x), // apparently width 0 TD's don't count, also remove TxnID
            showColumn: showDetails
                ? true
                : x.toLocaleLowerCase() !== 'general',
            group: null
        }));

        // this takes the column groups and sets up the columns under each group with an IColumn structure
        this.cols = flatDeep(
            this.colGroups.map(
                cg =>
                    Object.keys(item[cg.field])
                        .map(x => ({
                            group: cg.field,
                            field: x,
                            header: x,
                            exportable: x === 'TxnID' ? false : true,
                            style:
                                x === 'TxnID'
                                    ? 'width:0;display:none;'
                                    : 'width: 8em;',
                            // style: 'width: 7em',
                            class:
                                x === 'Amount'
                                    ? 'currency'
                                    : x === 'Hours'
                                    ? 'hours'
                                    : `disabled ${
                                          x.includes('Amount') ? 'currency' : ''
                                      }`,
                            // class: 'currency',
                            showColumn: showDetails
                                ? true
                                : cg.field.toLocaleLowerCase() !== 'general'
                        }))
                        .filter(x => x.showColumn)
                // .filter(x => x.group.toLocaleLowerCase() !== 'general' || this.showDetails)
            )
        );
        this.log.verbose({
            type: 'BurdenContainerComponent:mapColumns',
            cols: this.cols,
            colgroups: this.colGroups,
            item
        });
    }
    onSelectContract($event) {
        this.log.verbose({
            type: 'BurdenContainerComponent:onSelectContract',
            $event
        });
        this.LoadCloneSubject.next(true);
        this.SelectContractsSubject.next($event);
    }
    onToggleDetails($event: boolean) {
        this.log.verbose({
            type: 'BurdenContainerComponent:onToggleDetails',
            $event
        });
        this.LoadCloneSubject.next(true);
        this.ToggleDetailsSubject.next($event);
    }
    onSaveItem(item: BurdenModel) {

        this.log.verbose({
            type: 'BurdenContainerComponent:onSaveItem',
            item
        });
        this.LoadCloneSubject.next(false);
        this.BurdenModelDS.update(item);
    }
}
